import { Component, OnInit } from '@angular/core';
import { MmpiaService } from 'src/app/services/mmpia.service';
import Swal from 'sweetalert2';

declare var $:any;

@Component({
  selector: 'app-create-mmpia-factor',
  templateUrl: './create-mmpia-factor.component.html',
  styleUrls: ['./create-mmpia-factor.component.css']
})
export class CreateMmpiaFactorComponent implements OnInit {

  public type = "validez";
  public lastType = "validez";
  public scale = [];
  public value = "";
  public title = "";
  public subcategory = "";
  public selectedIndex;
  public scales;
  public loadingScales = false;
  public scalesArray = [];
  public isEditing = false;
  public editingIndex = 0;

  constructor(
    private mmpiaService:MmpiaService
  ) { 
    this.loadingScales = true;
    this.mmpiaService.getScales().subscribe(
      resp=>{
        this.loadingScales = false;
        this.scales = resp;
        this.scale = resp.validez;
        this.scales.all.map(
          scale=>{
            if(scale.type=='basicas') {
              if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='F1'||scale.scale=='F2'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') this.scalesArray.push(scale)
            }             }
        )
      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  addToScale(){
    let obj = {
      value:this.value,
      title:this.title,
      type:this.type=='lingoes'?'clinicas':this.type
    }
    this.mmpiaService.createScale(obj).subscribe(
      resp=>{
        if(this.type!="clinicas"){
          if (!this.isEditing) this.scale.push(obj)
          this.value="";
          this.title="";
        }
        Swal.fire("Escala actualizada");
        if (this.isEditing) this.scale[this.editingIndex].title = obj.title;
        this.isEditing = false;
        this.title = "";
        this.value = "";
      },
      err=>console.log(err)
    )
  }
  addSubcategory(){
    let obj = {
      value:this.value,
      title:this.subcategory,
      type:this.type
    }
    this.mmpiaService.createScale(obj).subscribe(
      resp=>{
        if (!this.isEditing) this.scale.push(obj);
        Swal.fire("Escala actualizada");
        if (this.isEditing) this.scale[this.editingIndex].title = obj.title;
        this.isEditing = false;
        this.title = "";
        this.value = "";
      },
      err=>console.log(err)
    )
    this.subcategory="";
    this.title = "";
    this.value="";
  }

  update(){
    let obj = {
      value:this.value,
      title:this.title,
      type:this.type
    }
    this.mmpiaService.createScale(obj).subscribe(
      resp=>{
        Swal.fire("Escala actualizada");
        this.scale[this.editingIndex].title = obj.title;
        this.isEditing = false;
        this.title = "";
        this.value = "";
      },
      err=>console.log(err)
    )
  }

  addToSubscale(){
    this.scale[this.selectedIndex].subScales.push({
      value:this.value,
      title:this.title
    })
    $('.subModal').modal('hide');
    this.value="";
    this.title="";
  }

  changeScale(e){
    Swal.fire({
      icon:'question',
      title:'¿Cambiar escala?',
      text:'Si cambia de escala sin guardar los cambios, estos se perderán',
      showCancelButton:true,
      confirmButtonText:'Cambiar',
      cancelButtonText:'Cancelar'
    }).then(
      resp=>{
        if(resp.isConfirmed){
          this.scalesArray = [];
          this.scales.all.map(
            scale=>{
              if(e=='validez'&&scale.type=='basicas') {
                if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='F1'||scale.scale=='F2'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') this.scalesArray.push(scale)
              }
              if(e=='clinicas'&&(scale.type=='basicas')) {
                if (scale.scale!='L'&&scale.scale!='?'&&scale.scale!='F'&&scale.scale!='F1'&&scale.scale!='F2'&&scale.scale!='K'&&scale.scale!='FB'&&scale.scale!='F(P)'&&scale.scale!='VRIN'&&scale.scale!='TRIN') this.scalesArray.push(scale)
              }
              if(e=='lingoes'&&(scale.type=='lingoes')) {
                this.scalesArray.push(scale)
              }
              if(e=='contenido'&&scale.type=='contenido') this.scalesArray.push(scale)
              if(e=='suplementarias'&&scale.type=='suplementarias') this.scalesArray.push(scale)

            }
          )
          this.type=e;
          this.lastType=e;
          if (e=='lingoes'||e=='clinicas') {
            this.scale = this.scales['clinicas'];
            let aux = []
            this.scale.map(
              scale=>{
                this.scalesArray.map(
                  s=>{
                    if (s.scale==scale.value) aux.push(scale);
                  }
                )
              }
            )
            this.scale = aux;
          }
          else this.scale = this.scales[e];
          this.value = "";
          this.title = "";
          this.subcategory = "";
        }else{
          $('#scaleSelector').val(this.lastType);
        }
      }
    )
  }

  handleEdit(scale,i){
    this.isEditing = true;
    this.editingIndex = i;
    this.value = scale.value;
    this.subcategory=scale.title;
    this.title = scale.title;
  }

  deleteScale(i, _id){
    Swal.fire({
      icon:'question',
      title:'¿Borrar escala?',
      showCancelButton:true
    }).then(
      resp=>{
        if(resp.isConfirmed){
          this.scale.splice(i,1)
          this.mmpiaService.deleteScale(_id, this.type).subscribe(
            resp=>{
              Swal.fire("Escala borrada");
            },
            err=>console.log(err)
          )
        }
      }
    )
  }

}
